import React from "react";
import classnames from "classnames";

import { LinkSpec } from "./linkSpec";
import { UniversalLinkWrapper } from "./universalLink";

type MenuItemProps = LinkSpec & {
  label: string;
  active?: boolean;
};

export const MenuItem = (props: MenuItemProps) => {
  const className = classnames("block txt-body-14 cursor-pointer", {
    "text-body hover:text-black": !props.active,
    "text-black": props.active,
  });
  return (
    <UniversalLinkWrapper className={className} spec={props}>
      {props.label}
    </UniversalLinkWrapper>
  );
};
